import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Observable, of, SubscriptionLike } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-email-list',
  templateUrl: './email-list.component.html',
  styleUrls: ['./email-list.component.scss']
})
export class EmailListComponent implements OnInit, OnDestroy {
  subGetDataPost: SubscriptionLike;
  subGetData: SubscriptionLike;

  @Output() MessageID: EventEmitter<any> = new EventEmitter();
  collapesedOrNot:any=false;
  emailsList$: Observable<any[]>;
  ApplicationID: string;
  ModuleID: string;
  SubModule:string;
  dateFormat = localStorage.getItem("_Dateformate") ?? 'DD MMM YYYY';
  datetimeFormat = this.dateFormat + ' ' + localStorage.getItem("_Timeformate");
  timeFormat: any = localStorage.getItem("_Timeformate");
  activeFolder: "I" | "O" = "I";
  EmailListSearchform: UntypedFormGroup;
  IsAdvanceSearch: boolean = false;
  keywords: string = "";
  isNewestFirst: boolean = true;
  isNotFoundSearchResult = false;

  constructor(public apiService: ApidataRequestService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public route: ActivatedRoute,
    private commonService: CommonService) { }

  ngOnDestroy(): void {
    if (this.subGetData)
      this.subGetData.unsubscribe();
    if (this.subGetDataPost)
      this.subGetDataPost.unsubscribe();
  }
  ngOnInit(): void {
    this.keywords = "";
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        // ;
        this.ModuleID =  this.commonService.getModuleId(params['module']);
        this.ApplicationID = params['id'];
        this.SubModule = params['submodule'];
      }
    });
    this.loadMails("I");
    this.isNewestFirst = true;
    this.IsAdvanceSearch = false;
    this.EmailListSearchform = new UntypedFormGroup({
      Keywords: new UntypedFormControl(null)

    });
  }

  searchMails() {
    this.isNewestFirst = true;
    this.keywords = this.EmailListSearchform.controls["Keywords"].value;
    if (this.keywords != "") {
      let searchObj = {
        ApplicationID: this.ApplicationID,
        ModuleID: this.ModuleID,
        SubModule:this.SubModule,
        KeyWords: this.keywords,
        Folder: this.activeFolder
      }
      this.subGetDataPost = this.apiService.getDataPost("api/Correspondence/SearchMails/", searchObj).subscribe(result => {
        if (result.Status && result.Data.length > 0) {
          this.emailsList$ = of(result.Data);
          this.isNotFoundSearchResult = false;
        } else {
          this.emailsList$ = of([]);
          this.isNotFoundSearchResult = true;
        }
      });
    }
  }

  toggleCase() {
    this.IsAdvanceSearch = !this.IsAdvanceSearch;
  }

  clearSearch() {
    this.keywords = "";
    this.isNewestFirst = true;
    this.EmailListSearchform.reset();
    this.loadMails(this.activeFolder);
  }

  sort() {
    this.isNewestFirst = !this.isNewestFirst;
    this.emailsList$ = this.emailsList$.pipe(map((data) => {
      if (!this.isNewestFirst) {
        data.sort((a, b) => {
          return a.Sent_Recvd_Dt < b.Sent_Recvd_Dt ? -1 : 1;
        });
      }
      else {
        data.sort((a, b) => {
          return a.Sent_Recvd_Dt > b.Sent_Recvd_Dt ? -1 : 1;
        });
      }
      return data;
    }))
  }

  initialize(folder: "I" | "O", ApplicationID, ModuleID,SubModule) {
     ;
    this.ApplicationID = ApplicationID;
    this.ModuleID = ModuleID;
    this.SubModule=SubModule;
    this.activeFolder = folder;
    this.IsAdvanceSearch = this.IsAdvanceSearch;
    this.isNewestFirst = true;
    this.loadMails(folder);
  }

  reloadEmails() {
    this.loadMails(this.activeFolder);
  }

  loadMails(folder) {
     ;
    this.keywords = "";
    this.subGetData = this.apiService.getData("api/Correspondence/GetEmails?ApplicationID=" + this.ApplicationID + "&ModuleID=" + this.ModuleID +"&SubModule="+this.SubModule+ "&folder=" + folder).subscribe(result => {
       
      if (result.Status && result.Data.length > 0) {
        this.emailsList$ = of(result.Data);
        this.isNotFoundSearchResult = false;
      } else {
        this.emailsList$ = of([]);
        this.isNotFoundSearchResult = false;
      }
    });
  }

  readEmail(msgID) {
     
    let abc = { msgID: msgID, folder: this.activeFolder };
    this.MessageID.emit(abc);
  }


}
